import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import Spinner from '../../components/widgets/Spinner';
import { PageHeader } from '../../components/partials';
import Button from '../../components/atoms/Button';
import TextField from '../../components/molecules/TextField';
import useConfirmDialog from '../../partnerIntegration/useConfirmDialog';
import RulesTable from './components/RulesTable';
import EmptyState from './components/EmptyState';
import WarningMessage from '../../components/utilities/WarningMessage';
import useFraudRules from './hooks';
import { FAQ_LINK, TRANSLATION_KEY } from './constants';
import css from './style.css';

const FraudCustomRules = ({ translate = () => {} }) => {
    const { confirm, dialog } = useConfirmDialog();
    const {
        rules,
        editing,
        searchText,
        sortKey,
        sortDir,
        rejectSaveDisabled,
        loading,
        saving,
        loadError,
        actions,
        newRuleOpen,
    } = useFraudRules({ confirm, translate });

    const header = <PageHeader text="STATIC.PAGE_HEADERS.FRAUD_CUSTOM_RULES" subText={{ faqLink: FAQ_LINK }} />;

    if (loading) {
        return (
            <div className={css.page}>
                {header}
                <div className={css.spinnerWrapper}>
                    <Spinner show />
                </div>
            </div>
        );
    }

    if (loadError) {
        return (
            <div className={css.page}>
                {header}
                <WarningMessage show type="error" showIcon={false} message={`${TRANSLATION_KEY}.LOAD_ERROR`} />
            </div>
        );
    }

    return (
        <div className={css.page}>
            {header}
            {dialog}

            {rules.length ? (
                <>
                    <div className={css.toolbar}>
                        <TextField
                            containerClass={css.searchContainer}
                            inputClassName={css.searchInput}
                            placeholder={`${TRANSLATION_KEY}.SEARCH_PLACEHOLDER`}
                            value={searchText || ''}
                            onChange={value => actions.search(value)}
                        />
                        <Button
                            type="primary"
                            text={`${TRANSLATION_KEY}.CREATE_RULE`}
                            disabled={newRuleOpen}
                            onClick={() => actions.newRule(null)}
                        />
                    </div>
                    <RulesTable
                        rules={rules}
                        editing={editing}
                        searchText={searchText}
                        sortKey={sortKey}
                        sortDir={sortDir}
                        rejectSaveDisabled={rejectSaveDisabled}
                        saving={saving}
                        translate={translate}
                        actions={actions}
                    />
                </>
            ) : (
                <EmptyState translate={translate} onCreate={() => actions.newRule(null)} />
            )}
        </div>
    );
};

FraudCustomRules.propTypes = {
    translate: PropTypes.func,
};

export default withLocalize(FraudCustomRules);
